module.exports = __webpack_public_path__ + "assets/img/tabs-gift-f1aecb4d.png";